import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoDigiSacForm } from "./components/IntegracaoDigiSacForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração DigiSac" />
            <Loading />
            <IntegracaoDigiSacForm />
        </>
    )
}
